import { render } from "./ManageLessonsInClassRoom.vue?vue&type=template&id=2fa0605e&scoped=true"
import script from "./ManageLessonsInClassRoom.vue?vue&type=script&lang=js"
export * from "./ManageLessonsInClassRoom.vue?vue&type=script&lang=js"

import "./ManageLessonsInClassRoom.vue?vue&type=style&index=0&id=2fa0605e&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/JEEducation.Student_STAGING/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fa0605e"]])

export default __exports__